import styled from 'styled-components';
import { GROOM, BRIDE, SCHEDULE, VENUE } from '../../utils/constants';
import MainImage from '../../assets/images/main.png';
import IconHeart from '../../assets/icon/icon-heart.svg';

const MainThumbnail = () => {
  return (
    <StyledHeader>
      <StyledSection>
        <StyledH1>
          <strong>{GROOM.name}</strong>
          <img src={IconHeart} alt="하트" />
          <strong>{BRIDE.name}</strong>
        </StyledH1>
        <StyledImg src={MainImage} alt="" />
      </StyledSection>
      <StyledStrong>
        <time dateTime={SCHEDULE.datetime}>
          2025년 6월 1일 일요일 오전 11시
        </time>
        <address>{VENUE.name}</address>
      </StyledStrong>
    </StyledHeader>
  );
};

const StyledHeader = styled.header`
  display: flex;
  flex-direction: column;
`;

const StyledSection = styled.section`
  display: flex;
  justify-content: space-between;
`;

const StyledH1 = styled.h1`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 6rem 2rem 0;
  font-size: 2rem;

  & > img {
    width: 2.4rem;
    height: 2.4rem;
    margin-left: -0.4rem;
  }

  & > strong {
    font-weight: 400;
    width: 2.4rem;
  }
`;

const StyledImg = styled.img`
  max-width: calc(100% - 6.7rem);
  height: auto;
  border-bottom-left-radius: 8rem;
`;

const StyledStrong = styled.strong`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 3rem 2rem 0;
  text-align: center;
  font-size: 1.8rem;
  line-height; 2rem;
  font-weight: 400;
`;

export default MainThumbnail;
